<template>
  <div class="base-search-condition-modal">
    <el-row class="search-box">
      <div class="search-input">
        <el-input
            :disabled="noCondition"
            :value="keyword"
            placeholder="テキスト検索"
            clearable
            @input="setStoreState($event, storePath + '/searchKeyword')"
            @keyup.enter.native="search" />
        <el-button :disabled="noSearch"
            @click="search">
          検索
        </el-button>
      </div>
      <div>
        <el-checkbox
            :disabled="noCondition"
            :value="isAndSearch"
            class="search-check-box"
            @input="setStoreState($event, storePath + '/isAndSearch')">
          AND検索
        </el-checkbox>
      </div>
      <div>
        <el-button :disabled="noCondition"
            @click="clear">
          クリア
        </el-button>
      </div>
      <div>
        <el-button
            :disabled="disableAddConditions || noCondition"
            @click="modalOpen">
          条件追加
        </el-button>
        <el-button
            v-if="isShowSaveCondition"
            :disabled="disableAddConditions || noCondition"
            @click="saveModalOpen">
          条件保存
        </el-button>
      </div>
      <div v-if="isMaxGetCount"
          class="maxGetCount">
        <div class="label"><span>取得件数</span></div>
        <el-select :value="maxGetCount"
            class="selectBox right"
            @change="setStoreState($event, storePath + '/maxGetCount')">
          <el-option
              v-for="item in maxGetCountList"
              :key="item.value"
              :label="item.label"
              :value="item.value" />
        </el-select>
      </div>
    </el-row>

    <el-dialog
        ref="searchModal"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        hide-footer
        class="base-search-condition-modal"
        title="検索条件">
      <div class="dialog-inner">
        <div
            v-for="(item, index) in displayItems"
            :key="index">
          <el-checkbox
              v-model="item.display"
              :disabled="item.required"
              :checked="item.display"
              border>
            {{ item.title }}
          </el-checkbox>
        </div>
      </div>
      <div class="dialog-bottom center">
        <el-button @click="modalSelect"> 全選択 </el-button>
        <el-button @click="modalClear"> クリア </el-button>
        <el-button @click="modalClose"> 閉じる </el-button>
      </div>
    </el-dialog>

    <el-row class="base-search-condition">
      <BaseSearchCondition
          v-for="(condition, index) in displayItems"
          :key="index"
          :item="condition"
          :name="index"
          :validation-scope="validationScope"
          :store-path="storePath" />
      <div class="layoutAdjustment" />
      <div class="layoutAdjustment" />
      <div class="layoutAdjustment" />
      <div class="layoutAdjustment" />
    </el-row>

    <!-- 検索条件設定保存 -->
    <BaseSearchConditionSaveModal
        :function-key="functionKey"
        :search-conditions="conditions"
        :keyword="keyword"
        :is-and-search="isAndSearch"
        :visible.sync="isSearchConditionSaveDialog" />
  </div>
</template>

<style scoped>
  .search-check-box {
    padding: 12px 0px;
  }
  .layoutAdjustment{
    width: 448px;
    padding: 0px;
  }
  .maxGetCount {
    display: flex;
  }
  .maxGetCount .label {
    color: #606266;
    font-size: 14px;
    font-weight: 500;
    font-family: sans-serif;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-right: 5px;
  }
  .maxGetCount .selectBox {
    width: 80px;
  }
</style>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import common from '@/utils/common'
import BaseSearchCondition from '@/components/organisms/BaseSearchCondition'
import BaseSearchConditionSaveModal from '@/components/organisms/BaseSearchConditionSaveModal'
import message from '@/utils/message'

export default {
  name: 'BaseSearchConditionModal',
  components: {
    BaseSearchCondition,
    BaseSearchConditionSaveModal
  },
  props: {
    // 機能キー
    functionKey: {
      type: String,
      default: null
    },
    // 検索未対応コンポーネント用
    noCondition: {
      type: Boolean
    },
    // 検索ボタンの活性
    noSearch: {
      type: Boolean,
      default: false
    },
    // 検索条件
    conditions: {
      type: Object,
      required: true
    },
    // テキスト検索
    keyword: {
      type: String,
      required: true
    },
    // AND検索有無
    isAndSearch: {
      type: Boolean,
      required: true
    },
    // store パス
    storePath: {
      type: String,
      required: true
    },
    // GraphQL Query
    baseQuery: {
      type: String,
      default: null
    },
    // GraphQL response data path
    resPath: {
      type: String,
      required: true
    },
    // localstorage key
    saveKey: {
      type: String,
      required: true
    },
    // バリデーションは条件のみを対象とするか
    isValidationOnlyCondition: {
      type: Boolean,
      required: false
    },
    // 取得件数の選択が可能であるかどうか
    isMaxGetCount: {
      type: Boolean,
      required: false,
      default: false
    },
    // 取得件数
    maxGetCount: {
      type: Number,
      required: false,
      default: 1000
    }
  },
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      dialogVisible: false,
      isSearchConditionSaveDialog: false
    }
  },
  computed: {
    ...mapGetters({
      searchConditions: 'searchConditions'
    }),
    uid () {
      return this._uid.toString()
    },
    validationScope () {
      return `searchCondition_${this.uid}`
    },
    disableAddConditions () {
      return this.conditions == null || Object.keys(this.conditions).length === 0
    },
    isShowSaveCondition () {
      return this.functionKey !== null
    },
    displayItems () {
      let v = {}
      Object.keys(this.conditions).forEach((key) => {
        // keyword と isAndSearch は検索条件選択モーダルに表示しない
        if (['keyword', 'isAndSearch'].includes(key)) return
        v[key] = this.conditions[key]
      })
      return v
    },
    maxGetCountList () {
      return [{
        value: 10,
        label: '10'
      }, {
        value: 25,
        label: '25'
      }, {
        value: 50,
        label: '50'
      }, {
        value: 100,
        label: '100'
      }, {
        value: 500,
        label: '500'
      }, {
        value: 1000,
        label: '1000'
      }]
    }
  },
  created () {
    // 必須入力である場合、初期表示として表示しておく。その後、編集不可。
    Object.keys(this.conditions).forEach((key) => {
      const condition = this.conditions[key]
      if (condition.required) {
        condition.display = true
      }
    })

    // 最大取得件数の初期化(最大取得件数の設定がローカルストレージにあるのに、取得件数の制御の権限がない場合)
    if (!this.isMaxGetCount) {
      this.setStoreState(null, this.storePath + '/maxGetCount')
    }
  },
  methods: {
    modalOpen: function () {
      this.dialogVisible = true
    },
    modalClose: function () {
      this.$refs.searchModal.hide()
    },
    modalClear: function () {
      this.allDispChange(false)
    },
    // 全選択
    modalSelect: function () {
      this.allDispChange(true)
    },
    // 検索条件保存モーダル
    saveModalOpen: function () {
      this.isSearchConditionSaveDialog = true
    },
    /**
     * 検索条件の display プロパティを更新します。
     * @param {Boolean} isShow 更新する値
     */
    allDispChange: function (isShow) {
      Object.keys(this.conditions).forEach(function (key) {
        if (!this.conditions[key].required) {
          // キーワード と AND検索 は全選択の対象外
          if (['keyword', 'isAndSearch'].includes(key)) return
          this.$store.dispatch({
            type: 'setValue',
            states: {
              target: this.conditions[key],
              key: 'display',
              value: isShow
            }
          })
        }
      }, this)
    },
    // 検索処理を実行します。
    search: async function () {
      try {
        await this.$validator.validate()
        if (this.errors.items.find((data) => {
          // 指定がある場合、検索条件のみをバリデーションチェックの対象とする
          return (!this.isValidationOnlyCondition || data.scope === this.validationScope) &&
            data.scope !== 'configSave' // 検索条件名のバリデーションは除く
        })) {
          return
        }
        this.$loadingService.show()
        const tdLists = this.storePath + '/tdLists'
        const totalCount = this.storePath + '/totalCount'
        const currentPage = this.storePath + '/currentPage'
        // 一覧とページを初期化
        this.$store.dispatch({
          type: 'set',
          states: {
            [tdLists]: [],
            [totalCount]: 0,
            [currentPage]: 0
          }
        })
        common.saveSearchConditions(this.saveKey, this.keyword, this.isAndSearch, this.conditions, (this.isMaxGetCount ? this.maxGetCount : null))

        // TODO 商品管理のための暫定処理。全体的にemitするだけにするか検討が必要。
        if (!this.baseQuery) {
          this.$emit('search', this.keyword, this.conditions)
          return
        }

        let queryCondition = this.searchConditions(this.storePath)

        const query = common.addGraphQlCondition(this.baseQuery, queryCondition)
        const res = await common.postGraphQl(query)

        this.$emit('dataConvert', common.getValueByPath(res.data, this.resPath))

        // ローカルストレージ、セッションストレージのバイト数
        let localStorageDataSize = escape(encodeURIComponent(JSON.stringify(window.localStorage))).length
        let sessionStorageDataSize = escape(encodeURIComponent(JSON.stringify(window.sessionStorage))).length
        const newDataSize = escape(encodeURIComponent(JSON.stringify(common.getValueByPath(res.data, this.resPath)))).length

        // 9MBを超える場合、tdListsを削除
        if (1024 * 1024 * 9 < (localStorageDataSize + sessionStorageDataSize + newDataSize)) {
          Object.keys(this.$store.state).filter((key) => {
            return Boolean(_.get(this.$store.state, `${key}.tdLists`, null))
          }).forEach((key) => {
            const tdListsPath = key + '/tdLists'
            const totalCountPath = key + '/totalCount'
            const currentPagePath = key + '/currentPage'
            // 一覧とページを初期化
            this.$store.dispatch({
              type: 'set',
              states: {
                [tdListsPath]: [],
                [totalCountPath]: 0,
                [currentPagePath]: 0
              }
            })
          })
        }

        // tdLists削除後、9MBを超える場合エラーメッセージを表示
        localStorageDataSize = escape(encodeURIComponent(JSON.stringify(window.localStorage))).length
        sessionStorageDataSize = escape(encodeURIComponent(JSON.stringify(window.sessionStorage))).length
        if (1024 * 1024 * 9 < (localStorageDataSize + sessionStorageDataSize + newDataSize)) {
          this.$notify.error({ error: message.MSG_902 })
          return
        }

        const totalCountPathArray = this.resPath.split('.')
        totalCountPathArray.pop()
        totalCountPathArray.push('totalCount')
        this.$store.dispatch({
          type: 'set',
          states: {
            [tdLists]: common.getValueByPath(res.data, this.resPath),
            [totalCount]: common.getValueByPath(res.data, totalCountPathArray.join('.')) || 0
          }
        })
        this.$emit('searched', res.data)
      } catch (error) {
        this.$log.debug(error)
        this.$log.debug(JSON.stringify(error, null, 2))
        this.$notify.error({ error: error })
        throw error
      } finally {
        this.$loadingService.close()
      }
    },

    clear: async function () {
      this.$store.dispatch({
        type: 'set',
        states: {
          [`${this.storePath}/searchKeyword`]: '',
          [`${this.storePath}/isAndSearch`]: false
        }
      })
      Object.keys(this.conditions).forEach(key => {
        switch (this.conditions[key]['type']) {
          case 'MultiSelector':
          case 'NumberRange':
            this.conditions[key]['value'] = []
            break
          default :
            this.conditions[key]['value'] = ''
            break
        }
      })

      setTimeout(() => {
        this.$validator.validate()
      }, 100)
    },
    /**
     * 更新処理を行います。(v-model を利用できないため、bind した値を強制的に更新する)
     * @param {*} val 値
     * @param {String} path state の property
     */
    setStoreState: function (val, path) {
      this.$store.dispatch({
        type: 'set',
        states: { [path]: val }
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/organisms/BaseSearchConditionModal.vue